(function(){
  // Remove any leftover sticky bar from cached HTML
  function purgeSticky(){
    document.querySelectorAll('.cm-sticky').forEach(function(el){ el.remove(); });
  }
  // Stock countdown — déclenche un sentiment d'urgence en temps réel
  function initStockCounter(){
    var els = [document.getElementById('cm-stock-count'), document.getElementById('cm-stock-count-2')].filter(Boolean);
    if(!els.length) return;
    // Stock pseudo-aléatoire basé sur le timestamp pour cohérence à travers les éléments
    var now = Date.now();
    var seed = Math.floor(now / 1000 / 60 / 17); // change toutes les ~17 minutes
    var stock = 47 - (seed % 8); // oscille entre 39 et 47
    if(stock < 23) stock = 23 + (seed % 5);
    els.forEach(function(el){ el.textContent = stock; });
    // Décrément aléatoire toutes les 60-180 secondes pour effet temps-réel
    setInterval(function(){
      if(Math.random() < 0.4 && stock > 19){
        stock--;
        els.forEach(function(el){
          el.textContent = stock;
          el.style.transition = 'color .4s';
          el.style.color = '#ff4444';
          setTimeout(function(){ el.style.color = ''; }, 600);
        });
      }
    }, 60000 + Math.random() * 120000);
  }
  // UGC slider: autoplay only active slide, click-to-unmute, sync dots
  function initUgc(){
    var track = document.getElementById('cm-ugc-track');
    var slides = document.querySelectorAll('.cm-ugc-slide');
    var dots = document.querySelectorAll('#cm-ugc-dots button');
    if(!track || !slides.length) return;

    function playOnly(activeVideo){
      slides.forEach(function(slide){
        var v = slide.querySelector('video');
        var btn = slide.querySelector('.cm-ugc-sound');
        var ov = slide.querySelector('.cm-ugc-overlay');
        if(!v) return;
        if(v === activeVideo){
          // Lazy-load src on first activation (saves bandwidth on 4G)
          if(!v.src && v.dataset.src){ v.src = v.dataset.src; }
          v.play().catch(function(){});
        } else {
          v.pause();
          v.muted = true;
          v.currentTime = 0;
          if(btn) btn.textContent = '🔇';
          if(ov) ov.classList.remove('hidden');
        }
      });
    }

    function unmuteSlide(slide){
      var v = slide.querySelector('video');
      var btn = slide.querySelector('.cm-ugc-sound');
      var ov = slide.querySelector('.cm-ugc-overlay');
      if(!v) return;
      v.muted = false;
      v.currentTime = 0;
      v.play().catch(function(){});
      if(btn) btn.textContent = '🔊';
      if(ov) ov.classList.add('hidden');
    }

    function toggleMute(slide){
      var v = slide.querySelector('video');
      var btn = slide.querySelector('.cm-ugc-sound');
      var ov = slide.querySelector('.cm-ugc-overlay');
      if(!v) return;
      if(v.muted){ unmuteSlide(slide); }
      else { v.muted = true; if(btn) btn.textContent='🔇'; if(ov) ov.classList.remove('hidden'); }
    }

    function setActive(idx){
      dots.forEach(function(d,i){ d.classList.toggle('active', i===idx); });
      var activeSlide = slides[idx];
      if(activeSlide) playOnly(activeSlide.querySelector('video'));
    }

    // Click on slide → unmute. Click on sound button → toggle.
    slides.forEach(function(slide){
      var soundBtn = slide.querySelector('.cm-ugc-sound');
      var ugc = slide.querySelector('.cm-ugc');
      if(ugc){
        ugc.addEventListener('click', function(e){
          if(e.target.closest('.cm-ugc-sound')) return;
          var v = slide.querySelector('video');
          if(v && v.muted) unmuteSlide(slide);
        });
      }
      if(soundBtn){
        soundBtn.addEventListener('click', function(e){
          e.stopPropagation();
          toggleMute(slide);
        });
      }
    });

    // Dots → scroll to slide
    dots.forEach(function(d, i){
      d.addEventListener('click', function(){
        var slide = slides[i];
        if(slide) slide.scrollIntoView({behavior:'smooth', inline:'center', block:'nearest'});
      });
    });

    // IntersectionObserver: detect which slide is currently in viewport center
    var slideObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting && entry.intersectionRatio > 0.6){
          var idx = parseInt(entry.target.getAttribute('data-idx'), 10);
          setActive(idx);
        }
      });
    }, { root: track, threshold: [0.6] });

    slides.forEach(function(s){ slideObserver.observe(s); });

    // Start by playing the first slide
    setTimeout(function(){ setActive(0); }, 100);
  }
  // Hide WhatsApp floating when EasySell form is in viewport
  // Smart-scroll fallback: if CTAs point to #commander but EasySell hasn't loaded yet, scroll to end of body
  function initSmartCtas(){
    document.querySelectorAll('a[href="#commander"]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        var target = document.getElementById('easysell') || document.getElementById('commander');
        if(target){
          target.scrollIntoView({behavior:'smooth', block:'start'});
        } else {
          // Last resort: scroll to bottom of page where EasySell form will eventually appear
          window.scrollTo({top: document.body.scrollHeight, behavior:'smooth'});
        }
        // Re-trigger scroll after 2s in case EasySell loaded meanwhile
        setTimeout(function(){
          var es = document.getElementById('easysell');
          if(es){
            var rect = es.getBoundingClientRect();
            if(rect.top < -100 || rect.top > window.innerHeight){
              es.scrollIntoView({behavior:'smooth', block:'start'});
            }
          }
        }, 2000);
      });
    });
  }

  function init(){
    purgeSticky();
    initStockCounter();
    initSmartCtas();
    initUgc();
    var form = document.getElementById('easysell');
    if(!form){ return setTimeout(init, 500); } // EasySell loads async; retry
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        document.body.classList.toggle('cm-form-visible', e.isIntersecting);
      });
    }, { threshold: 0.05 });
    io.observe(form);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();